import "./ModalProtocolEditor.scss";
import "react-quill/dist/quill.snow.css";

import { useEffect, useMemo, useState } from "react";

import AppButton from "../../../../../commons/buttons/AppButton";
import AppLinkButton from "../../../../../commons/buttons/AppLinkButton";
import { Modal } from "react-bootstrap";
import ReactQuill from "react-quill";

function ModalProtocolEditor({ show, closeShow, initialHtml, onApply }) {
  const [draftHtml, setDraftHtml] = useState(initialHtml || "");

  useEffect(() => {
    if (show) setDraftHtml(initialHtml || "");
  }, [show, initialHtml]);

  const quillModules = useMemo(
    () => ({
      toolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["clean"],
      ],
    }),
    []
  );

  const quillFormats = useMemo(
    () => [
      "bold",
      "italic",
      "underline",
      "strike",
      "color",
      "background",
      "align",
      "list",
      "bullet",
      "link",
    ],
    []
  );

  function cancel() {
    // NÃO aplica alterações
    closeShow?.();
  }

  function applyAndClose() {
    // aplica no modal pai e fecha
    onApply?.(draftHtml);
    closeShow?.();
  }

  return (
    <Modal show={show} fullscreen onHide={cancel} className="proto-editor-modal">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 15 }}>EDITAR PROTOCOLO</Modal.Title>
      </Modal.Header>

      <Modal.Body className="proto-editor-modal__body">
        <div className="proto-editor-modal__wrap">
          <div className="proto-editor-modal__label">
            Conteúdo do protocolo <span>(tela cheia)</span>
          </div>

          <div className="proto-editor-modal__box">
            <ReactQuill
              theme="snow"
              value={draftHtml}
              onChange={setDraftHtml}
              modules={quillModules}
              formats={quillFormats}
              placeholder="Digite o protocolo... (negrito, cores, listas, etc.)"
            />
          </div>

          <div className="proto-editor-modal__footer">
            <AppLinkButton name="cancelar" onClick={cancel} />
            <AppButton name="fechar edição" onClick={applyAndClose} />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalProtocolEditor;
